import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=574ae875&scoped=true&lang=pug&"
import script from "./TicketInfo.vue?vue&type=script&lang=js&"
export * from "./TicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=574ae875&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ae875",
  null
  
)

export default component.exports